import React from "react";
import { ChatAudio, proxyPeaksUrl } from "@/components/chat/ChatMedia";
import { resolveMediaUrl } from "@/components/FileUpload";
import { avatarSrc } from "@/lib/defaults";
import { useApp } from "@/context/AppContext";
import { resumeEnabled } from "@/lib/videoProgress";

// Lot 685 — LE lecteur d'une publication SON, partout où elle s'affiche (carte du fil / profil, page et modale de
// commentaires, Découvrir) : forme d'onde serveur (lot 684) + piste du lecteur partagé (lib/nowPlaying) → le même
// son continue d'un écran à l'autre et la barre flottante sait toujours de quelle publication il s'agit.
// Lot 686 — `resume` / `resumeAt` : reprise là où le membre s'était arrêté (position mémorisée sur le compte,
// `post.resume_t`), si le membre est connecté et que la reprise de lecture est activée dans l'admin.
export const postTrack = (post, author = post?.author || {}, { resume = false } = {}) => ({
  id: post.id,
  title: author.name || "",
  subtitle: String(post.content || "").replace(/\s+/g, " ").trim().slice(0, 60),
  avatar: author.avatar_url ? avatarSrc(author, 64) : null,
  resume,
  resumeAt: resume ? Number(post.resume_t) || 0 : 0,
});

export const PostAudioPlayer = ({ post, author, testId }) => {
  const { user, config } = useApp();
  const resume = !!user && resumeEnabled(config);
  return (
    <ChatAudio
      url={resolveMediaUrl(post.audio_url)}
      peaksUrl={proxyPeaksUrl(post.audio_url)}
      duration={post.audio_duration}
      maxMeasured={Infinity}
      track={postTrack(post, author, { resume })}
      testId={testId}
    />
  );
};

export default PostAudioPlayer;
